export const UPDATE_GP = 'other/UPDATE_GP';
export const USER_ME = 'me/USER_ME';
export const USER_ONBOARD = 'me/USER_ONBOARD';
export const USER_LOGIN = 'me/USER_LOGIN';
export const USER_LOGOUT = 'me/USER_LOGOUT';